import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import type { IProps } from '~/src/components/PromotionalCard/types';
import check from '~/static/images/icons/check.svg';

/**
 * Пропсы компонента по умолчанию
 *
 * @name constants.DEFAULT_PROPS
 * @type {Required<IProps>}
 */
export const DEFAULT_PROPS: Required<IProps> = {
    id: null,
    bgColor: COLORS.BgSurface,
    imgUrl: 'initial',
    imgWebp: '',
    imgSize: 'cover',
    labelData: [],
    labelTextColor: COLORS.TextWhite,
    titleFont: FONTS.H4,
    titleColor: COLORS.TextPrimary,
    descriptionFont: FONTS.XS,
    descriptionColor: COLORS.TextHint,
    buttonFont: FONTS.MediumS,
    title: '',
    description: '',
    btnTypes: btnTypes.SECONDARY,
    callback: null,
    link: '',
    symbolId: 'check',
    iconsSprite: check,
    renderPopup: null,
    setCardKey: null,
    setIsPopupOpenOut: null,
    popupProps: null,
    textConnected: 'Подключено',
    textNotConnected: 'Подробнее',
    duration: '',
    isConnected: false,
    cardKey: 0,
    promoText: '',
    sendVasGA: null,
    advertiserName: '',
    advertiserErid: '',
};

/**
 * Атрибуты для тестирования
 *
 * @name constants.TEST_NAMES_ATTR
 * @type {Record<string, string>}
 */
export const TEST_NAMES_ATTR: Record<string, string> = {
    label: 'label',
    image: 'image',
    titleAttr: 'title',
    descriptionAttr: 'description',
    buttonAttr: 'button',
    container: 'container',
    labelsBlock: 'labelsBlock',
    textLabelAttr: 'textLabel',
    promoTextAttr: 'promoText',
};

/**
 * Значение для tabindex
 *
 * @name constants.TAB_INDEX
 * @type {number}
 */
export const TAB_INDEX = 1;

/**
 * Значение свойства объекта props в массиве
 *
 * @name constants.VALUE_IN_ARR
 * @type {number}
 */
export const VALUE_IN_ARR = 1;
